import React from 'react'

import { Icon } from '@st-operations/uikit/src/v2'

import { OMM_STATUS_OPTIONS } from '../constants'

import './styles.scss'

const InvalidDetails = ({ data }) => {
  return (
    <div className="tab-invalid-details">
      <div className="tab-invalid-details__header">
        <h3 className="tab-invalid-details__header-title">Invalid Details</h3>
      </div>
      <div className="tab-invalid-details__content">
        <If condition={data.status === OMM_STATUS_OPTIONS.SIZE_LOW}>
          <div className="tab-invalid-details__guide-info">
            <Icon icon="idea" type="fill" color="#13682b" />
            <p className="tab-invalid-details__error-title">Expand your audience</p>
            <p className="tab-invalid-details__error-message">
              Your audience doesn't have enough candidate URLs, or the User Count for the selected
              URLs might be too small (fewer than 25) to proceed. To continue, select more candidate
              URLs, or clone the audience and add additional Reference URLs or Keywords for
              Contextual Expansion. If you need assistance, please contact us at{' '}
              <a href="mailto:onlinemediameasurement@sharethis.com">
                onlinemediameasurement@sharethis.com
              </a>
              .
            </p>
          </div>
        </If>
        <If condition={data.status === OMM_STATUS_OPTIONS.INVALID}>
          <div className="tab-invalid-details__guide-info">
            <Icon icon="idea" type="fill" color="#13682b" />
            <p className="tab-invalid-details__error-title">Add-in more Reference URLs</p>
            <p className="tab-invalid-details__error-message">
              No exact match results were found for the provided Reference URLs within the specified
              lookback window. To resolve this, please add more URLs to the Reference URLs list that
              are not login-protected pages, or adjust the lookback window and try again. If you
              need assistance, please contact us at{' '}
              <a href="mailto:onlinemediameasurement@sharethis.com">
                onlinemediameasurement@sharethis.com
              </a>
              .
            </p>
          </div>
        </If>
        <If condition={window._isShareThisUser}>
          <div className="tab-invalid-details__error-info">
            <Icon icon="info" type="fill" color="#f76d1e" />
            <p className="tab-invalid-details__error-title">Error description</p>
            <p className="tab-invalid-details__error-message">{data.statusMessage}</p>
            <p className="tab-invalid-details__error-note">For ShareThis users.</p>
          </div>
        </If>
      </div>
    </div>
  )
}

export default InvalidDetails
